import React, { useState, useCallback } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import { TRACKING_TAB, type TrackingTab } from '../constants/booking';
import LiveTrackingTab from './tracking/components/live-tracking/LiveTracking';
import StaffLiveTrackingTab from './tracking/components/staff-live-tracking/StaffLiveTracking';
import AllBookingsTab from './tracking/components/all-bookings/AllBookings';

const Tracking: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TrackingTab>(TRACKING_TAB.LIVE);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [refreshBookingsTrigger, setRefreshBookingsTrigger] = useState(0);
  const [bookingsStatusFilter, setBookingsStatusFilter] = useState<string | undefined>(undefined);
  const [useLast24Hours, setUseLast24Hours] = useState(false);
  const [selectedBookingCard, setSelectedBookingCard] = useState<string | null>(null);

  // Callback to trigger refresh of live tracking
  const handleRefreshLiveTracking = useCallback(() => {
    setRefreshTrigger((prev) => prev + 1);
  }, []);

  // Callback to trigger refresh of bookings (called when tracking API auto-refreshes)
  const handleRefreshBookings = useCallback(() => {
    setRefreshBookingsTrigger((prev) => prev + 1);
  }, []);

  return (
    <DashboardLayout>
      <div className="tracking-page" style={{ height: '100%', display: 'flex', flexDirection: 'column', margin: '-10px', padding: '0px' }}>
        {/* Tabs: Stretch to full width */}
        {/* <div className="tracking-tabs" style={{ display: 'flex', width: '100%', flexShrink: 0 , margin: '0px', padding: '0px'}}>
           <button
            className={`tracking-tab ${activeTab === TRACKING_TAB.LIVE ? 'active' : ''}`}
            onClick={() => setActiveTab(TRACKING_TAB.LIVE)}
            style={{
              flex: 1,
              width: '100%',
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0,
            }}
          >
            Live Tracking
          </button> 
           <button
            className={`tracking-tab ${activeTab === TRACKING_TAB.STAFF ? 'active' : ''}`}
            onClick={() => setActiveTab(TRACKING_TAB.STAFF)}
            style={{
              flex: 1,
              width: '100%',
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
            }}
          >
            Staff Live Tracking
          </button> 
        </div> */}

        <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          {activeTab === TRACKING_TAB.LIVE && (
            <LiveTrackingTab 
              refreshTrigger={refreshTrigger} 
              onTrackingDataRefreshed={handleRefreshBookings}
              onBookingFilterChange={(statusFilter, cardId) => {
                // If clicking the same card again, reset all filters
                if (selectedBookingCard === cardId) {
                  setBookingsStatusFilter(undefined);
                  setUseLast24Hours(false);
                  setSelectedBookingCard(null);
                } else {
                  setBookingsStatusFilter(statusFilter);
                  setUseLast24Hours(true); // Always apply 24-hour filter when clicking booking cards
                  setSelectedBookingCard(cardId);
                }
              }}
              selectedBookingCard={selectedBookingCard}
            />
          )}

          {activeTab === TRACKING_TAB.STAFF && (
            <StaffLiveTrackingTab />
          )}
        </div>

        {/* All Bookings Section - Only visible in Live Tracking tab */}
        {activeTab === TRACKING_TAB.LIVE && (
          <div id="bookings-section" style={{ flexShrink: 0, marginTop: '32px' }}>
            <AllBookingsTab 
              onActionPerformed={handleRefreshLiveTracking}
              refreshTrigger={refreshBookingsTrigger}
              externalStatusFilter={bookingsStatusFilter}
              useLast24Hours={useLast24Hours}
            />
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default Tracking;
